import { StrictMode } from 'react';
import { render } from 'react-dom';

import { App } from './App';
import { reportWebVitals } from './reportWebVitals';

import './css/index.css';

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
